import { isCurrentPathPresent } from ".";
import appConfig from "config.json";
import { canRenderGenesysChat } from "./canRenderValidation";
const { externalScripts, brands } = appConfig;

export const getQueryString = (queryParams) => {
	let queryString = Object.keys(queryParams)
		.map((key) => `${key}=${queryParams[key]}`)
		.join("&");
	return queryString ? "?" + queryString : "";
};

export const validateScript = ({
	script,
	currentBrand,
	currentEnvironment,
	currentLocale,
	currentStore,
}) => {
	const scriptConfig = {
		...(externalScripts?.[script] || {}),
		...(brands?.[currentBrand]?.externalScripts?.[script] || {}),
	};

	if (
		scriptConfig?.localStorageDisableKey &&
		window?.localStorage.getItem(scriptConfig.localStorageDisableKey)
	) {
		return null;
	}
	if (scriptConfig?.excludedBrands?.includes(currentBrand)) {
		return null;
	}
	if (
		scriptConfig?.allowedBrands &&
		!scriptConfig?.allowedBrands?.includes(currentBrand)
	) {
		return null;
	}
	if (scriptConfig?.excludedLocales?.includes(currentLocale)) {
		return null;
	}
	if (
		scriptConfig?.allowedEnvironments &&
		!scriptConfig.allowedEnvironments.includes(currentEnvironment)
	) {
		return null;
	}
	if (
		scriptConfig?.excludedEnvironments &&
		scriptConfig.excludedEnvironments.includes(currentEnvironment)
	) {
		return null;
	}
	if (
		scriptConfig?.allowedPages &&
		!isCurrentPathPresent(scriptConfig.allowedPages)
	) {
		return null;
	}
	if (scriptConfig?.preventLoadingInTradePages && currentStore) {
		return null;
	}
	if (
		scriptConfig?.excludedDomains?.length &&
		scriptConfig.excludedDomains.some((domain) =>
			window?.location.hostname.endsWith(domain)
		)
	) {
		return null;
	}
	if (
		scriptConfig?.checkForGenesys &&
		canRenderGenesysChat("genesys", appConfig, currentBrand, currentEnvironment)
	) {
		return null;
	}
	if (
		scriptConfig?.excludedScriptPages &&
		isCurrentPathPresent(scriptConfig.excludedScriptPages)
	) {
		return null;
	}
	const queryParams = {};
	const brandScriptQueryParameters =
		brands[currentBrand]?.externalScripts?.[script]?.queryParameters;
	Object.keys(externalScripts[script]?.queryParameters || []).forEach(
		(param) => {
			const paramValue =
				brandScriptQueryParameters?.[param]?.[currentEnvironment] ||
				brandScriptQueryParameters?.[param]?.lowers ||
				externalScripts[script]?.queryParameters?.[param]?.[
					currentEnvironment
				] ||
				externalScripts[script]?.queryParameters?.[param]?.lowers;
			queryParams[param] = paramValue;
		}
	);

	const queryString = getQueryString(queryParams);
	return `${
		scriptConfig?.relativeUrl ?? `scripts/${script}.min.js`
	}${queryString}`;
};

export const dynamicallyLoadScript = (url, cdnAssetsUrl, position = "body") => {
	const navigationCurrentScript = document?.querySelector(
		'script[src*="' + url.split("?")[0] + '"]'
	);
	if (navigationCurrentScript) {
		return;
	}
	let script = document?.createElement("script");
	script.src = url.startsWith("scripts") ? `${cdnAssetsUrl}/${url}` : url;
	script.defer = true;
	document?.[position]?.appendChild(script);
};
